"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressSchema = exports.LocationCoordinateSchema = void 0;
const zod_1 = require("zod");
const _1 = require(".");
const __1 = require("..");
exports.LocationCoordinateSchema = zod_1.z.object({
    latitude: zod_1.z.number(),
    longitude: zod_1.z.number(),
});
exports.AddressSchema = zod_1.z.object({
    addressLine1: _1.ShortStringSchema,
    addressLine2: _1.ShortStringSchema.optional(),
    addressLine3: _1.ShortStringSchema.optional(),
    streetNumber: _1.ShortStringSchema.optional(),
    zipCode: _1.ShortStringSchema.optional(),
    neighborhood: _1.ShortStringSchema.optional(),
    municipality: _1.ShortStringSchema.optional(),
    city: _1.ShortStringSchema.optional(),
    cityCode: _1.ShortStringSchema.optional(),
    stateOrRegion: _1.ShortStringSchema.optional(),
    stateOrRegionCode: _1.ShortStringSchema.optional(),
    countryCode: zod_1.z.nativeEnum(_1.Alpha3Countries).optional(),
    country: _1.ShortStringSchema.optional(),
    coordinates: exports.LocationCoordinateSchema.optional(),
    type: zod_1.z.nativeEnum(__1.AddressType).optional(),
});
//# sourceMappingURL=address.js.map